import DocumentModal from './DocumentModal';

export default DocumentModal;
